import React from 'react';
import { connect } from 'react-redux';
import SaveCohortDialog from './SaveCohortDialog';
import CohortDeletionDialog from './CohortDeletionDialog';
import ShareCohortDialog from '../sharing/containers/ShareCohortDialog';
import RenameQueryDialog from '../queries/containers/RenameQueryDialog';
import RenameClauseDialog from '../clauses/containers/RenameClauseDialog';

const CohortDialogs = ({
  allowDelete,
  allowEditClause,
  allowEditQuery,
  allowSave,
  allowShare,
  theme,
}) => (
  <>
    {allowDelete && (<CohortDeletionDialog theme={theme} />)}
    {allowEditClause && (<RenameClauseDialog theme={theme} />)}
    {allowEditQuery && (<RenameQueryDialog theme={theme} />)}
    {allowSave && (<SaveCohortDialog theme={theme} />)}
    {allowShare && (<ShareCohortDialog theme={theme} />)}
  </>
);

const mapStateToProps = ({
  auth: {
    role: {
      permissions: {
        cohorts: {
          secure, share, create, destroy,
        },
      },
    },
  },
  cohorts: {
    activeCohort, activeClause, activeQuery, sharingCohort, deleteCohortOpen,
  },
}) => ({
  allowDelete: deleteCohortOpen && destroy,
  allowEditClause: activeClause.open && create,
  allowEditQuery: activeQuery.open && create,
  allowSave: activeCohort.open && create,
  allowShare: sharingCohort.open && (secure || share),
});

export default connect(mapStateToProps)(CohortDialogs);
